import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import SpamRequestsTableWrapper from './table/SpamRequestsTableWrapper';

export function SpamRequestsCard() {
  return (
    <Container>
      <Row>
        <Col md={12}>
          <h3 className="page-title">Spam Requests</h3>
        </Col>
      </Row>
      <Row>
        <SpamRequestsTableWrapper />
      </Row>
    </Container>
  );
}
